/**
 * Ensures that a SQL statement ends with a semicolon.
 * @param sql - The SQL statement to check
 * @returns The SQL statement with a semicolon at the end
 */
export const ensureSemicolon = (sql: string): string => {
  const trimmed = sql.trim();
  return trimmed.endsWith(";") ? trimmed : `${trimmed};`;
};
